import LegalPage from './LegalPage'

export default function Terms() {
  return (
    <LegalPage title="Terms of Service">
      <p className="mt-4 text-sm text-slate-700">
        InnovateFlow is operated by InnovateFlow Pty Ltd, Sydney, Australia. Your documents are encrypted and hosted
        in Australia, and only you hold the keys to your disclosures.
      </p>
    </LegalPage>
  )
}
